export default __webpack_public_path__ + "static/article-tips-for-travelling-on-a-shoestring-6ddd55b305e393b7b6c57da0946d8e9d.jpg";